import { createStore } from 'redux';

import rootReducer from './rootReducers';
import thunk from 'redux-thunk';
import { applyMiddleware } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';


const persistConfig = {
    key: 'root',
    storage,
    //  blacklist: ['notesSettings'] 
  };
  
  const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = createStore(persistedReducer, applyMiddleware(thunk))
const persistor = persistStore(store);

export  { store, persistor };


